export default __webpack_public_path__ + "static/media/checkers-9-rMAX.31535d00.jpg";